export default __webpack_public_path__ + "static/toyota_red-96c913d956b6361c8baac25dd1dc2447.jpg";